<template>
	<div class="onboarding-breadcrumb">
		<router-link class="btn btn-primary mb-2" :to="back">
			<font-awesome-icon :icon="['fas', 'arrow-circle-left']" class="me-1" />
			Back
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" to="/">🏠 MC2</router-link>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	name: 'Breadcrumb',
	components: {},
	data() {
		return {
			dashboardUrl: process.env.VUE_APP_DASHBOARD_URL,
			client: {},
		}
	},
	props: ['back'],
	computed: {
		...mapState(['authUser', 'tokenJuniper']),
		...mapGetters(['isAuth']),
	},
	created() {},
	methods: {},
}
</script>
